<template>
  <div class="school-list-page w">
    <!-- 主标签页切换 -->
    <el-card class="main-container">
      <template #header>
        <div class="tab-header">
          <el-button
            v-for="tab in tabs"
            :key="tab.name"
            :class="['tab-button', { active: activeTab === tab.name }]"
            @click="activeTab = tab.name"
          >
            {{ tab.label }}
          </el-button>
        </div>
      </template>

      <!-- 院校列表 -->
      <div v-if="activeTab === 'schoolList'" class="tab-content">
        <SchoolListContent />
      </div>

      <!-- 报考条件 -->
      <div v-if="activeTab === 'condition'" class="tab-content">
        <ConditionContent />
      </div>

      <!-- 招生信息 -->
      <div v-if="activeTab === 'require'" class="tab-content">
        <RequireContent />
      </div>

      <!-- 报考流程 -->
      <div v-if="activeTab === 'process'" class="tab-content">
        <ProcessContent />
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import SchoolListContent from "@/components/school/SchoolListContent.vue";
import ConditionContent from "@/components/school/ConditionContent.vue";
import RequireContent from "@/components/school/RequireContent.vue";
import ProcessContent from "@/components/school/ProcessContent.vue";

const route = useRoute();

// 主标签页
const activeTab = ref("schoolList");
const tabs = ref([
  { name: "schoolList", label: "院校列表" },
  { name: "condition", label: "报考条件" },
  { name: "require", label: "招生信息" },
  { name: "process", label: "报考流程" },
]);

// 页面加载时读取 URL 参数中的 tab
onMounted(() => {
  const tabParam = route.query.tab;
  if (tabParam && tabs.value.some(tab => tab.name === tabParam)) {
    activeTab.value = tabParam;
  }
});
</script>

<style scoped>
.school-list-page {
  max-width: 1440px;
  margin: 60px auto;
}

.main-container {
  margin-top: 10px;
}

.tab-header {
  display: flex;
  gap: 6px;
}

.tab-button {
  padding: 20px 20px;
  border: none;
  border-radius: 4px;
  background-color: #f5f7fa;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
  font-size:16px;
}

.tab-button:hover {
  background-color: #e8f0fe;
  color: #409eff;
}

.tab-button.active {
  background-color: #409eff;
  color: white;
}

.tab-content {
  padding: 5px 0;
}
</style>
